<template>
  <v-dialog
    :value="getDialog('addFinancier')"
    width="500px"
    @input="handleDialogInput"
  >
    <v-card>
      <v-card-title>Bayii Ekle</v-card-title>
      <v-container>
        <v-row class="mx-2">
          <v-col cols="12">
            <v-text-field v-model="newFinancierData.name" label="Bayii Adı" />
            <!-- <v-text-field v-model="newFinancierData.website" label="Website" /> -->
            <!-- <v-text-field
              v-model="newFinancierData.companyApiKey"
              label="Api Key"
            /> -->
            <v-text-field
              v-model="newFinancierData.firmaEmail"
              label="Mail Adresi"
            />
            <v-text-field v-model="newFinancierData.limit" label="Limit" />
            <v-text-field
              v-model="newFinancierData.firmaSifre"
              label="Şifre"
              :type="showPassword ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-text-field
              v-model="newFinancierData.firmaSifre2"
              label="Şifre Tekrar"
              :type="showPassword ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-switch
              v-model="newFinancierData.active"
              :label="newFinancierData.active ? 'Aktif' : 'Deaktif'"
            ></v-switch>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-btn text color="primary" @click="handleCancel">İptal</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="handleAddFinancier">Ekle</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//import { v4 as uuidv4 } from "uuid";

export default {
  name: "add-financier",
  data() {
    return {
      dialog: false,
      showPassword: false,
      newFinancierData: {
        name: null,
        //website: null,
        //  companyApiKey: uuidv4(),
        active: true,
        limit: null,
        firmaEmail: null,
        firmaSifre: null,
        firmaSifre2: null,
      },
    };
  },
  methods: {
    handleAddFinancier() {
      for (const key in this.newFinancierData) {
        if (!this.newFinancierData[key]) {
          return this.setWarning("Lütfen bütün alanları doldurunuz");
        }
      }

      if (
        this.newFinancierData.firmaSifre != this.newFinancierData.firmaSifre2
      ) {
        return this.setWarning(
          "Şifreler uyuşmuyor, Lütfen kontrol edip tekrar deneyiniz."
        );
      }

      this.addFinancier(this.newFinancierData);
      this.setDialog({ dialogName: "addFinancier", status: false });
    },
    handleDialogInput(e) {
      this.setDialog({ dialogName: "addFinancier", status: e });
    },
    handleCancel() {
      this.setDialog({ dialogName: "addFinancier", status: false });
    },
  },
};
</script>
